'use client';

import { createFileRoute } from '@tanstack/react-router';
import { Leaf } from 'lucide-react';

import { GHGOverviewDashboard } from '@/features/analytics/predefined-dashboards';
import { useActiveOrganizationId } from '@/hooks/use-active-org-id';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/analytics/ghg-overview')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.ghgOverview'),
  }),
  component: GHGOverviewPage,
});

function GHGOverviewPage() {
  const { organizationId: orgId } = useActiveOrganizationId();

  return (
    <div className="min-h-screen bg-background p-6 lg:p-8">
      <div className="mx-auto max-w-[1400px] space-y-8">
        <div className="flex items-center gap-3">
          <Leaf className="h-7 w-7 text-primary" />
          <h1 className="text-3xl font-semibold text-foreground">GHG Overview</h1>
        </div>
        <GHGOverviewDashboard organizationId={orgId} />
      </div>
    </div>
  );
}
